<template>
    <div>

        <TabComponent
            :tabs="tabs"
        >
        </TabComponent>

        <!-- Content -->
		<slot name="contents" />
    </div>
</template>

<script setup lang="ts">
import TabComponent from '@/components/TabComponent.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const isDependent = computed( ()=> route.query?.dependent == 'true');

const props = defineProps({
    patientId: {
        type: String || Number,
        required: true
    }
})

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        count: 0,
        href: '/accounts/patients/show/' + props.patientId,
        allowed: true
    },
    {
        name: 'Dependents',
        count: 0,
        href: '/accounts/patients/show/' + props.patientId + '/dependents',
        allowed: !isDependent.value && window.$hasPermission('view-dependents')
    },
    {
        name: 'Bookings',
        count: 0,
        href: '/accounts/patients/bookings/' + props.patientId,
        allowed: window.$hasPermission('view-corporate-patients') || ( isDependent.value || window.$hasPermission('view-booking-of-dependents'))
    },
    {
        name: 'Medical Records',
        count: 0,
        href: '/accounts/patients/medical-record/show/' + props.patientId,
        allowed: 
            window.$hasPermission('view-corporate-patient-medical-records') ||
            window.$hasPermission('view-web-booking-medical-records') ||
            window.$hasPermission('view-contact-center-booking-medical-records') ||
            window.$hasPermission('view-patient-medical-records') ||
            window.$hasPermission('view-medical-records-in-offline')
    },
    // {
    //     name: 'Blocked Dates',
    //     count: 0,
    //     href: ''
    // }
];

</script>